var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 294 293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3{stroke-width:0px;}.cls-3{fill:#ffc400;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.04,
    y: 23,
    width: 249.96,
    height: 250
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    className: "cls-3",
    d: "M27.93,246.98c-.53-2.11-.83-4.27-.89-6.45V68.84c0-12.13-.53-23.1,7.38-33.15,6.53-8.13,16.43-12.81,26.86-12.69,60.4,0,120.81-.08,181.21.08,2.66-.02,5.31.27,7.91.86,15.9,3.27,27.13,17.54,26.55,33.77v154.43c0,9.28.15,18.57-.08,27.79-.28,15.36-10.95,28.57-25.91,32.08l-3.38.89h-58.07c0-1,.08-1.92.08-2.91.08-27.7.15-55.49.23-83.2v-3.23h29.63c4.6,0,6.45-1.92,6.83-6.67.62-7.98,1.46-15.97,2.84-23.79,1.15-6.45-.77-9.13-6.83-9.13h-32.91c.3-10.52.62-20.72,1.07-30.93.2-1.61.75-3.16,1.61-4.53,2.71-4.41,7.61-7,12.78-6.75,5.6-.3,11.2-.15,16.81-.23,4.68-.08,6.67-2.07,6.75-6.67.08-7.29.08-14.66,0-21.95,0-4.53-1.99-6.6-6.52-6.6-9.21,0-18.42-.15-27.55.3-10.09.25-19.8,3.91-27.55,10.36-9.9,8.62-15.59,21.1-15.58,34.23-.46,10.13-.3,20.34-.3,30.47,0,1.79-.46,2.38-2.31,2.38-6.68-.08-13.35-.08-20.03,0-3.06-.4-5.87,1.76-6.27,4.82-.07.51-.06,1.03.01,1.55,0,8.98,0,17.87.08,26.87-.47,3.09,1.66,5.98,4.75,6.45.56.09,1.14.09,1.7,0h22.26v2.22c-.08,28.32-.15,56.61-.23,84.88-.04.72-.12,1.44-.23,2.15h-86.34c-3.54.11-7.09-.13-10.59-.71-.15,0-.3-.08-.46-.08-11.26-.64-20.85-8.41-23.79-19.3l-1.49-5.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.45e894c4ad6d10eee1834434243f14c6.svg";
export { ForwardRef as ReactComponent };